/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    bottom: PropTypes.bool,
    inner: PropTypes.bool,
    fluid: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    bottom: false,
    inner: false,
    fluid: false,
};

const Tab = (props) => {
    const classNames = [
        'c-tab',
        props.className,
        props.bottom ? 'c-tab--bottom' : '',
        props.inner ? 'c-tab--inner' : '',
        props.fluid ? 'c-tab--fluid' : '',
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Tab.propTypes = propTypes;

Tab.defaultProps = defaultProps;

export default Tab;
